import React from 'react';
import { ChevronRight, MessageCircle } from 'lucide-react';

const CommunicationManagement = ({ onNavigate, onSendReminders, permissions }) => {
    // Communication is typically allowed for Admins and Captains
    // Everyone in the admin dashboard probably has some communication rights?
    // Let's restrict to canManageTeams for now
    if (!permissions.canManageTeams) return null;

    return (
        <div>
            <h3 className="text-lg font-bold text-gray-900 mb-3">📱 Communication</h3>
            <div className="grid grid-cols-2 gap-4">
                <button
                    onClick={onSendReminders}
                    className="group flex items-center gap-4 bg-gradient-to-r from-blue-50 to-sky-50 hover:from-blue-100 hover:to-sky-100 rounded-xl p-4 transition-all text-left border border-blue-100"
                >
                    <div className="p-2 bg-white rounded-lg shadow-sm group-hover:scale-110 transition-transform shrink-0">
                        <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                        </svg>
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="font-bold text-gray-900 truncate">Send Reminders</h3>
                        <p className="text-xs text-gray-500 truncate">Notify players</p>
                    </div>
                    <ChevronRight className="text-blue-300 group-hover:text-blue-600 transition-colors shrink-0" size={18} />
                </button>

                <button
                    onClick={() => onNavigate('whatsapp-messenger')}
                    className="group flex items-center gap-4 bg-gradient-to-r from-green-50 to-emerald-50 hover:from-green-100 hover:to-emerald-100 rounded-xl p-4 transition-all text-left border border-green-100"
                >
                    <div className="p-2 bg-white rounded-lg shadow-sm group-hover:scale-110 transition-transform shrink-0">
                        <MessageCircle className="text-green-600" size={20} />
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="font-bold text-gray-900 truncate">WhatsApp Chat</h3>
                        <p className="text-xs text-gray-500 truncate">Team announcements</p>
                    </div>
                    <ChevronRight className="text-green-300 group-hover:text-green-600 transition-colors shrink-0" size={18} />
                </button>
            </div>
        </div>
    );
};

export default CommunicationManagement;
